import { globalVariables } from "helper/globalVariables";
import { arrowLeft, arrowRight } from "helper/icons";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { DOTS, usePagination } from "./usePagination";
import Loader from "../loader";
import "./style.css";
import { Button } from "../button";

export const TableWithPagination = (props) => {
  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const {
    zIndex = "z-1",
    headData,
    headDateWithStyle = false,
    tableBody,
    title,
    showButtons = false,
    headerComponent,
    isHeaderComponentRow = false,
    paddingVertical = "py-2",
    paddingHorizontal = "px-6",
    // tableHeight = "h-[600px]",
    handlePageChange,
    totalPage = 1,
    loading = false,
    error = "",
    current = 1,
    persistPagination,
    isPagination = true,
    viewEntriesHandler,
    overflow = "overflow-auto",
    mainOverflow,
    extraClass,
    padding,
    noMargin = false,
    columnWidths,
  } = props || {};

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (persistPagination) {
      setCurrentPage(current);
    }
  }, [current, persistPagination]);

  const currentItems = tableBody;
  const paginationRange = usePagination({
    currentPage,
    totalPages: totalPage,
  });

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    handlePageChange(pageNumber);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
      handlePageChange(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPage) {
      setCurrentPage((prevPage) => prevPage + 1);
      handlePageChange(currentPage + 1);
    }
  };

  return (
    <div
      className={`w-full border bg-white border-purple-100  rounded-md shadow-100 ${mainOverflow} ${
        isMobile && "pb-20"
      } relative ${!noMargin && "mb-10"}`}
    >
      {(title || headerComponent) && (
        <div
          className={`${title && "bg-lightBlue/60"} ${paddingVertical} border-b ${
            isMobile
              ? `border-gray-200 ${
                  isHeaderComponentRow ? "flex-row" : "flex-col"
                } px-4`
              : "border-purple-100 flex-row items-center px-6"
          } flex justify-between`}
        >
          <div>
            {!!title && (
              <span className="font-semibold text-lg text-gray-900">
                {title}
              </span>
            )}
          </div>
          {!!headerComponent && <div className="w-full">{headerComponent}</div>}
        </div>
      )}
      <div
        className={`table-container ${overflow} ${padding} ${
          //max-h-full
          !loading && !error && currentItems?.length === 0
            ? "scrollbar-hide"
            : ""
        }`}
      >
        <table className={`min-w-full ${columnWidths ? 'table-fixed' : ''}`}>
          {columnWidths && (
            <colgroup>
              {columnWidths.map((width, index) => (
                <col key={index} style={{ width }} />
              ))}
            </colgroup>
          )}
          <thead>
            <tr className={`sticky top-0 ${zIndex} ${!title && "bg-lightBlue/60"}`}>
              {headData?.map((head) => (
                <th
                  key={headDateWithStyle ? head?.label : head}
                  className={`text-center ${paddingHorizontal} py-3 text-sm font-lg text-gray-700 w-32 text-center h-14 ${
                    headDateWithStyle ? head?.style : ""
                  }`}
                >
                  {headDateWithStyle ? head?.label : head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!loading && !error && currentItems?.length > 0 ? (
              currentItems
            ) : loading ? (
              <tr>
                <td colSpan={headData?.length} className="relative">
                  <div className="flex justify-center items-center h-full">
                    <Loader stroke="text-gradient-500" />
                  </div>
                </td>
              </tr>
            ) : (
              <tr>
                {!showButtons ? (
                  <td colSpan={headData?.length} className="relative">
                    <div className="flex justify-center items-center h-full min-h-[10rem]">
                      {" "}
                      {/* Ensure adequate height for centering */}
                      <span className="font-semibold text-xl text-gray-900">
                        {error?.message ? "Something went wrong" : "No Records"}
                      </span>
                    </div>
                  </td>
                ) : (
                  <td colSpan={headData?.length} className="relative">
                    <div className="flex flex-col justify-center items-center h-full min-h-[10rem]">
                      {" "}
                      {/* Ensure adequate height for centering */}
                      {/* <span className="font-semibold text-xl text-gray-900">
                        {error?.message ? "Something went wrong" : "No Records"}
                      </span> */}
                      <span className=" mt-[10%] font-semibold text-xl text-gray-900">
                        You have already draw entries for this trial. Please
                        check already drawn data.
                      </span>
                      <div className="mt-10 flex gap-8 flex-row ">
                        {/* <Button
                          prefix={false}
                          width={"w-full md:w-44 lg:w-[220px]"}
                          label={globalVariables.cancelDraw}
                          // icon={EmailWhite}
                          // onClick={sendEmail}
                          // disabled={emailLoader}
                        /> */}
                        <Button
                          prefix={false}
                          width={"w-full md:w-44 lg:w-[220px]"}
                          label={globalVariables.viewDrawEntries}
                          // icon={EmailWhite}
                          onClick={viewEntriesHandler}
                          // disabled={emailLoader}
                        />
                      </div>
                    </div>
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!loading && !error && isPagination ? (
        <div
          className={` border-t border-purple-100 bottom-0 w-full bg-white h-[68px] flex items-center px-6 justify-between`}
        >
          <button onClick={goToPreviousPage}>
            {isMobile ? (
              <div className="rounded-lg border border-gray-300 h-9 w-9 flex items-center justify-center bg-white">
                <img src={arrowLeft} alt="" />
              </div>
            ) : (
              <div className="flex flex-row items-center">
                <img src={arrowLeft} alt="" />
                <span className="ml-2 text-sm font-semibold text-gray-600">
                  {globalVariables.previous}
                </span>
              </div>
            )}
          </button>
          {isMobile ? (
            <span className="text-sm font-normal text-gray-700">
              Page <span className="font-medium">{currentPage}</span> of{" "}
              <span className="font-medium">{totalPage}</span>
            </span>
          ) : (
            <ul className="pagination flex">
              {paginationRange?.map((pageNumber, index) => (
                <>
                  <li key={pageNumber} className="page-item">
                    {pageNumber === DOTS ? (
                      <button className="h-10 w-10 items-center mr-0.5">
                        ...
                      </button>
                    ) : (
                      <button
                        onClick={() => paginate(pageNumber)}
                        className={`${
                          pageNumber === currentPage
                            ? "text-gray-800 font-extrabold	 text-sm"
                            : "text-gray-600 text-sm font-medium"
                        } h-10 w-10 items-center mr-0.5`}
                      >
                        {pageNumber}
                      </button>
                    )}
                  </li>
                </>
              ))}
            </ul>
          )}
          <button onClick={goToNextPage}>
            {isMobile ? (
              <div className="rounded-lg border border-gray-300 h-9 w-9 flex items-center justify-center bg-white">
                <img src={arrowRight} alt="" />
              </div>
            ) : (
              <div className="flex flex-row items-center">
                <span className="mr-2 text-sm font-semibold text-gray-600">
                  {globalVariables.next}
                </span>
                <img src={arrowRight} alt="" />
              </div>
            )}
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
